import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_cabinet_curiosities: FaireCollectionEntity = {
  token: "col_cabinet-curiosities",
  type: "collection",
  name: "Cabinet of Curiosities",
  description: "Eclectic oddities and vintage finds.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  season: "fall",
  itemCount: 20,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
